export const Style = ({ colors }) => (
  <g id="Estilo1_1_">
    <path
      style={{ fill: colors[0] }}
      d="M85.4,64.7c-1.4,0.7-2.8,0.7-3.1,0.1c-0.3-0.6,0.7-1.6,2.1-2.3c1.4-0.7,2.8-0.7,3.1-0.1 C87.8,63,86.8,64,85.4,64.7z"
    />
    <path
      style={{ fill: colors[0] }}
      d="M65.9,64.9c1.5,0.6,2.8,0.6,3.1,0c0.2-0.6-0.7-1.6-2.2-2.2c-1.5-0.6-2.8-0.6-3.1,0 C63.5,63.3,64.4,64.3,65.9,64.9z"
    />
    <path
      style={{ fill: '#FF9673' }}
      d="M63.4,73.4c-0.1,0-0.2,0-0.2-0.1c-0.3-0.1-0.4-0.4-0.3-0.7l1.7-3.5c0.1-0.3,0.4-0.4,0.7-0.3 c0.3,0.1,0.4,0.4,0.3,0.7l-1.7,3.5C63.8,73.3,63.6,73.4,63.4,73.4z"
    />
    <path
      style={{ fill: '#FF9673' }}
      d="M60,73.4c-0.1,0-0.2,0-0.2-0.1c-0.3-0.1-0.4-0.4-0.3-0.7l1.7-3.5c0.1-0.3,0.5-0.4,0.7-0.3 s0.4,0.4,0.3,0.7l-1.7,3.5C60.4,73.3,60.2,73.4,60,73.4z"
    />
    <path
      style={{ fill: '#FF9673' }}
      d="M87.5,73.4c-0.2,0-0.4-0.1-0.5-0.3l-1.7-3.5c-0.1-0.3,0-0.6,0.3-0.7c0.3-0.1,0.6,0,0.7,0.3l1.7,3.5 c0.1,0.3,0,0.6-0.3,0.7C87.7,73.4,87.6,73.4,87.5,73.4z"
    />
    <path
      style={{ fill: '#FF9673' }}
      d="M90.9,73.4c-0.2,0-0.4-0.1-0.5-0.3l-1.7-3.5c-0.1-0.3,0-0.6,0.3-0.7c0.3-0.1,0.6,0,0.7,0.3l1.7,3.5 c0.1,0.3,0,0.6-0.3,0.7C91.1,73.4,91,73.4,90.9,73.4z"
    />
  </g>
)
